// 📄 components/credenciales/CredentialDeleteModal.tsx
import React, { useState } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

interface CredentialDeleteModalProps {
  nombre: string;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
}

export default function CredentialDeleteModal({ nombre, onConfirm, onCancel }: CredentialDeleteModalProps) {
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleConfirm = async () => {
    setError(null);
    setDeleting(true);
    try {
      await onConfirm();
    } catch (err: any) {
      setError(err.message || 'No se pudo eliminar la credencial.');
      setDeleting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4">
      <div className="bg-[rgb(var(--c-surface))] border border-white/10 rounded-2xl w-full max-w-md shadow-2xl p-6 space-y-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-red-500/15 flex items-center justify-center flex-shrink-0">
            <AlertTriangle className="w-5 h-5 text-red-400" />
          </div>
          <h3 className="text-base font-semibold text-white">Eliminar credencial</h3>
        </div>

        <p className="text-sm text-gray-400">
          ¿Eliminar <span className="text-white font-medium">{nombre}</span>? Esto también elimina la contraseña de Secret Manager. Esta acción no se puede deshacer.
        </p>

        {error && <p className="text-red-400 text-xs">{error}</p>}

        <div className="flex gap-3 pt-1">
          <button type="button" onClick={onCancel} disabled={deleting} className="flex-1 bg-white/5 hover:bg-white/10 border border-white/10 py-2 rounded-lg text-sm font-semibold transition-all disabled:opacity-50">
            Cancelar
          </button>
          <button type="button" onClick={handleConfirm} disabled={deleting} className="flex-1 flex items-center justify-center gap-2 bg-red-500 hover:bg-red-600 disabled:opacity-50 py-2 rounded-lg text-sm font-semibold transition-all">
            {deleting ? <RefreshCw className="w-4 h-4 animate-spin" /> : 'Eliminar'}
          </button>
        </div>
      </div>
    </div>
  );
}
